import React, { useContext, useEffect, useMemo } from 'react'
import { Table, Card, LoadingOverlay } from '../../../components/common'
import { ReactComponent as BinIcon } from '../../../assets/icons/sre-bin.svg'

import DocumentsQuickAccess from './DocumentsQuickAccess'

import styled from 'styled-components'
import { JobDocumentsContext } from 'stores/JobDocumentsStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'

const BoxlessTable = styled(Table)`
    box-shadow: none;
    cursor: pointer;
    overflow: hidden;
    table {
      width: 100%;
      height: 100%;
      white-space: nowrap;
      th, td {
        text-align: left;
        border-right: 0;
      }
    }
`

const CardMargin = styled(Card)`  
    margin: 10px 20px 30px 30px;
    overflow: hidden;
`

const BinDiv = styled.div`
    transition: transform .2s ease-in-out;
    &:hover {
        transform: scale(1.3);
    } 
`


const Documents = ({ src }) => {
    const { registryLog, registryLogOld, currentUser } = useContext(UserContext)
    const { jobDocuments, isDocumentsLoading, quickAccessDocuments, setFileIdToDownload, isFileDownloading, setFileIdToDelete, isFileDeleting, setSource } = useContext(JobDocumentsContext)
    const { t } = useTranslation()
    const deleteDocument = (row, e) => {
        console.log('delete')
        console.log(row)
        registryLogOld('click_deleteDocument', "running-expert/job-details")
        registryLog('job_details', "click", "delete_document")
        e.stopPropagation()
        if (row && row.row && row.row.original) {
            setFileIdToDelete(row.row.original.id)
        }
    }
    const rowClickHandler = (row) => {
        if (row && row.original) {
            setFileIdToDownload(row.original.id)
            // registryLogOld('click_openDocument', "running-expert/job-details")
            // registryLog('job_details', "click", "open_document")
        }
    }

    const tableColumns = useMemo(() => [
        {
            Header: t('Name'),
            accessor: 'name',
        },
        {
            Header: t('Pipe'),
            accessor: 'pipe',
        },
        {
            Header: t('Description'),
            accessor: 'description',
        },
        {
            Header: t('Upload By'),
            accessor: 'uploadedBy',
        },
        {
            Header: t('Upload On'),
            accessor: 'uploadDate',
        },
        {
            Header: t('File Type'),
            accessor: 'fileType',
        },
        {
            Header: t('File Size'),
            accessor: 'fileSize',
        },
        {
            Header: '',
            accessor: 'icon',
            Cell: (row) => (
                <BinDiv onClick={(e) => deleteDocument(row, e)}>
                    <BinIcon />
                </BinDiv>
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], [t])

    useEffect(() => {
        setSource(src)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src])


    return (
        <React.Fragment>
            <LoadingOverlay fixed={true} visible={isDocumentsLoading || isFileDownloading || isFileDeleting} />
            {currentUser.roles.MANAGE_JOB_DOCUMENTS.UPLOAD && <DocumentsQuickAccess docs={quickAccessDocuments}></DocumentsQuickAccess>}
            <CardMargin>
                <BoxlessTable margin="8px" width="calc(100% - 16px)" columns={tableColumns} data={jobDocuments} onRowClick={rowClickHandler} sortable />
            </CardMargin>
        </React.Fragment>
    )

}

export default Documents
